"use client";
import { StarIcon, UsersIcon, GiftIcon, TrendingUpIcon } from "lucide-react";

export function GrowthSystems() {
  return (
    <section className="py-12 md:py-20 relative z-10 border-t border-white/5 bg-gradient-to-b from-[#050505] to-[#0a0a0a]">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white tracking-tighter mb-4">
            Feito para você <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600">crescer.</span>
          </h2>
          <p className="text-lg text-white/50 max-w-2xl mx-auto">
            Não somos apenas uma agenda. O Agendei possui motores internos de crescimento 
            para trazer clientes novos e fidelizar os atuais.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          
          {/* Reviews System */}
          <div className="group relative overflow-hidden rounded-3xl bg-[#111]/50 backdrop-blur-sm border border-white/5 p-8 md:p-10 transition-all hover:border-yellow-500/30">
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            
            <div className="relative z-10 flex flex-col h-full">
              <div className="size-12 rounded-2xl bg-yellow-500/10 border border-yellow-500/20 flex items-center justify-center mb-6">
                <StarIcon className="size-6 text-yellow-500 fill-yellow-500" />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-3">Sistema de Avaliações</h3>
              <p className="text-white/60 leading-relaxed mb-8 flex-1">
                Após o atendimento, o cliente é convidado automaticamente a deixar uma nota. 
                Construa sua reputação online com depoimentos reais que aparecem na sua página.
              </p>

              <div className="bg-black/40 border border-white/5 rounded-2xl p-5">
                <div className="flex items-center justify-between mb-3">
                   <div className="flex gap-1">
                     {[1,2,3,4,5].map(i => <StarIcon key={i} className="size-4 text-yellow-500 fill-yellow-500" />)}
                   </div>
                   <span className="text-xs text-white/40">Ontem</span>
                </div>
                <p className="text-sm text-white/80 italic">&ldquo;Melhor atendimento da região! O agendamento foi super fácil e o resultado incrível.&rdquo;</p>
              </div>
            </div>
          </div>

          {/* Referral System */}
          <div className="group relative overflow-hidden rounded-3xl bg-[#111]/50 backdrop-blur-sm border border-white/5 p-8 md:p-10 transition-all hover:border-primary/30">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            
            <div className="relative z-10 flex flex-col h-full">
              <div className="size-12 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-6">
                <UsersIcon className="size-6 text-primary" />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-3">Indique e Ganhe</h3>
              <p className="text-white/60 leading-relaxed mb-8 flex-1">
                Transforme seus clientes em promotores. Um sistema de links de indicação 
                que rastreia quem trouxe quem, perfeito para criar programas de fidelidade ou comissões.
              </p>

              <div className="bg-black/40 border border-white/5 rounded-2xl p-5 flex items-center justify-between">
                <div className="flex items-center gap-3">
                   <div className="size-10 rounded-full bg-white/5 flex items-center justify-center">
                     <GiftIcon className="size-5 text-white/70" />
                   </div>
                   <div>
                     <p className="text-sm font-bold text-white">Código: <span className="text-primary">JOAO10</span></p>
                     <p className="text-xs text-white/40">3 indicações convertidas</p>
                   </div>
                </div>
                <div className="flex items-center gap-1 text-green-400 bg-green-400/10 px-3 py-1.5 rounded-lg text-xs font-bold">
                   <TrendingUpIcon className="size-3" />
                   R$ 45,00
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
